<template>
  <svg :width="width" :height="height" viewBox="0 0 78 66" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M39 0L0 66H78L39 0ZM39 1.96568L1.75245 65H76.2476L39 1.96568Z" fill="#80B7FF"/>
  </svg>
</template>

<script>
import {colors} from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 78 },
    height: { type: [Number, String], default: 66 },
    color: { type: String, default: colors.callIcon }
  }
}
</script>